import { render, staticRenderFns } from "./NewClassHour.vue?vue&type=template&id=0adc48f6&scoped=true"
import script from "./NewClassHour.vue?vue&type=script&lang=js"
export * from "./NewClassHour.vue?vue&type=script&lang=js"
import style0 from "./NewClassHour.vue?vue&type=style&index=0&id=0adc48f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adc48f6",
  null
  
)

export default component.exports